import style from './menu.module.scss';
import React, {useEffect, useMemo, useState} from "react";
import Slider from "react-slick";
import {Bar} from 'react-chartjs-2';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Scrollbars} from 'react-custom-scrollbars-2';
import {arrowRight, iconsSmile} from "../../util/assets";
import {ChartBar} from "./chart";
import moment from "moment-timezone";
import {outputNameHazard} from "../../util/util";
import {getLogs} from "../../thunk/device";
import {clearCurrentItem, setActiveMapData, setCurrentItem, setCurrentItemChangeActive} from "../../action/page";
import {getAddressMap} from "../../thunk/map";
import {setCurrentAlert} from "../../action/alert";
import {connect} from "react-redux";
import SliderForMenu from "./slider";
import CloseIcon from '@mui/icons-material/Close';

function Menu({
                  currentItem,
                  getLogs,
                  setCurrentItem,
                  getAddressMap,
                  page,
                  setCurrentAlert,
                  pointsBefore10Km,
                  map,
                  currentUser,
                  clearCurrentItem,
                  setCurrentItemChangeActive,
                  alerts
              }) {
    const handlerChangeStatus = (flug) => {
        let currentIndex = pointsBefore10Km.findIndex(item => item === currentItem._id); // next prev value
        let pointsBefore10KmLength = pointsBefore10Km.length;
        let id = "";
        let npi = 0;

        npi = flug === "n" ? currentIndex - 1 : currentIndex + 1;
        npi = npi < 0 ? pointsBefore10KmLength - 1 : npi > pointsBefore10KmLength - 1 ? 0 : npi;

        setCurrentItem({id: pointsBefore10Km[npi], status: "menuButton"});
    }
    const borderCenter = (distSize, coord) => {
        const dist = {big: 0.135, small: 0.045, less: 0.008} // big - 30km small - 10

        return [
            [
                coord.lat + dist[distSize],
                coord.lng - dist[distSize]
            ],
            [
                coord.lat - dist[distSize],
                coord.lng + dist[distSize]
            ]
        ];
    }
    useEffect(() => {
        // getLogs({id: currentItem._id});
        // if (currentItem.location && (page.state === "map" || page.state === "menuButton")) {
        if (currentItem.location && currentItem.location.length) {
            getAddressMap(currentItem.location.join(", "));
            setCurrentAlert({id: currentItem._id});
        }

        if (map && (page.state === "menuButton" || page.state === "pollutionAlerts") && window.google && currentItem.location) {
            let bounds = new window.google.maps.LatLngBounds();
            const coord = currentItem.location;
            const coordinates = borderCenter("less", {lat: coord[0], lng: coord[1]});

            bounds.extend(new window.google.maps.LatLng(coordinates[0][0], coordinates[0][1]));
            bounds.extend(new window.google.maps.LatLng(coordinates[1][0], coordinates[1][1]));
            map.fitBounds(bounds);
        }
    }, [
        currentItem
    ])

    // useMemo(() => {
    //     if (currentItem.active) {
    //         clearCurrentItem();
    //     }
    // }, [currentUser]);

    return (
        <div className={[style.menuRow, currentItem.active ? style.open : ""].join(" ")}>
            <div className={style.row}>
                {page.state !== "mapNotFound" && (
                    <Scrollbars style={{height: "calc(100vh - 134px)"}}>

                        <div className={style.container}>
                            <div
                                className={[style.baseInfo, style[`status${!isNaN(currentItem.aqi) ? currentItem.aqi : "Nan"}`]].join(" ")}>
                                <div className={style.baseInfoBlockH}>
                                    <div className={style.baseInfoBlock}>
                                        <div
                                            className={style.value}>{currentItem.aqiValue || currentItem.aqi || "No data"}</div>
                                        <div className={style.name}>
                                            <span>PM2.5</span>
                                            <span className={style.subName}>μg/m3</span>
                                        </div>
                                    </div>
                                    <div className={style.baseInfoBlock}>
                                        <div className={style.baseStatus}>
                                            {currentItem.aqi !== undefined && (
                                                <div className={style.icon}>
                                                    <img
                                                        src={iconsSmile(currentItem.aqi, currentItem.aqi === 1 ? "gray" : "")}
                                                        alt=""/>
                                                    {/*<IconsSmile*/}
                                                    {/*    index={currentItem.aqi}*/}
                                                    {/*    currentItem={currentItem}*/}
                                                    {/*/>*/}
                                                </div>
                                            )}
                                            <div className={style.text}>{outputNameHazard(currentItem.aqi)}</div>
                                        </div>
                                    </div>
                                </div>

                                {currentItem.description && (
                                    <div className={style.description}>
                                        {currentItem.description}
                                    </div>
                                ) || ""}
                            </div>
                            {/* {currentItem.iaqi && (
                                <SliderForMenu iaqi={currentItem.iaqi} aqi={currentItem.aqi}/>
                            )} */}
                            {/* {currentItem.aqi !== undefined && (
                                <ChartBar/>
                            )} */}

                            <div className={style.blockBarConteiner}>
                                {currentItem?.chartOne?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>AQI</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.chartOne && <ChartBar currentItem={currentItem.chartOne}/>}    
                                    </div>
                                </div>}
                                {currentItem?.dew?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>DEW</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.dew && <ChartBar currentItem={currentItem.dew}/>}
                                    </div>
                                </div>}
                                {currentItem?.h?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>HUMIDITY</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.h && <ChartBar currentItem={currentItem.h}/>}
                                    </div>
                                </div>}
                                {currentItem?.no2?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>NO2</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.no2 && <ChartBar currentItem={currentItem.no2}/>}
                                    </div>
                                </div>}
                                {currentItem?.o3?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>O3</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.o3 && <ChartBar currentItem={currentItem.o3}/>}
                                    </div>
                                </div>}
                                {currentItem?.p?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>PRESSURE</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.p && <ChartBar currentItem={currentItem.p}/>}
                                    </div>
                                </div>}
                                {currentItem?.pm25?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>PM2.5</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.pm25 && <ChartBar currentItem={currentItem.pm25}/>}
                                    </div>
                                </div>}
                                {currentItem?.so2?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>SO2</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.so2 && <ChartBar currentItem={currentItem.so2}/>}
                                    </div>
                                </div>}
                                {currentItem?.t?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>TEMPERATURE</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.t && <ChartBar currentItem={currentItem.t}/>}
                                    </div>
                                </div>}
                                {currentItem?.w?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>WIND SPEED</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.w && <ChartBar currentItem={currentItem.w}/>}
                                    </div>
                                </div>}
                                {currentItem?.wg?.data && <div className={style.blockBar}>
                                    {/* <div className={style.head}>WIND GUST</div> */}
                                    <div className={style.blockBarVertical}>
                                        {currentItem.wg && <ChartBar currentItem={currentItem.wg}/>}
                                    </div>
                                </div>}
                            </div>
                            



                            <div className={style.infoDevice}>
                                <div className={style.name}>
                                    <b>Sensor No:&nbsp;</b>
                                    <span>{currentItem.mac}</span>
                                </div>
                                <div className={style.address}>
                                    <b>Address:&nbsp;</b>
                                    <span>{currentItem.address}</span>
                                </div>
                                <div className={style.date}>
                                    <b>Date:&nbsp;</b>
                                    <span>{moment(currentItem.updated_at).format('DD/MM/YYYY')}</span>
                                </div>
                                <div className={style.time}>
                                    <b>Time:&nbsp;</b>
                                    {/*&nbsp;*/}
                                    <span>{moment(currentItem.updated_at).format('HH:mm:ss')}</span>
                                </div>
                                {currentItem.showSubInfo && (
                                    <>
                                        {currentItem.company && (
                                            <div className={style.address}>
                                                <b>Company Name:&nbsp;</b>
                                                <span>{currentItem.company.name}</span>
                                            </div>
                                        )}
                                        {/*{currentItem.title && (*/}
                                            <div className={style.address}>
                                                <b>Title:&nbsp;</b>
                                                <span>{currentItem.name}</span>
                                            </div>
                                        {/*)}*/}
                                    </>
                                )}
                            </div>

                            {pointsBefore10Km && pointsBefore10Km.length >= 2 && (
                                <div className={style.buttonsNavigation}>
                                    <div
                                        className={[style.button, style.prev].join(" ")}
                                        onClick={() => handlerChangeStatus("p")}
                                    >Prev. Sensor
                                    </div>
                                    <div
                                        className={[style.button, style.next].join(" ")}
                                        onClick={() => handlerChangeStatus("n")}
                                    >Next Sensor
                                    </div>
                                </div>
                            )}
                        </div>

                    </Scrollbars>
                )}

                {page.state === "mapNotFound" && (
                    <div className={style.mapNotFound}>
                        <b>Sorry :(</b>
                        <span>
                            There is no<br/>
                            air quality sensor <br/>
                            nearby yet.
                        </span>
                    </div>
                )}
            </div>
            <div className={style.close} onClick={() => setCurrentItem({active: false})}><CloseIcon /></div>
        </div>
    );
}

const mapStateToProps = state => ({
    page: state.page,
    currentItem: state.page.currentItem,
    currentUser: state.currentUser.user.filter,
    alerts: state.alerts,
    badges: state.page.badges,
    pointsBefore10Km: state.page.pointsBefore10Km
});

const mapDispatchToProps = dispatch => ({
    getAddressMap: data => dispatch(getAddressMap(data)),
    setActiveMapData: data => dispatch(setActiveMapData(data)),
    setCurrentItem: data => dispatch(setCurrentItem(data)),
    getLogs: data => dispatch(getLogs(data)),
    setCurrentAlert: data => dispatch(setCurrentAlert(data)),
    clearCurrentItem: data => dispatch(clearCurrentItem(data)),
    setCurrentItemChangeActive: data => dispatch(setCurrentItemChangeActive(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
